import { render, staticRenderFns } from "./edit-root-dirs.vue?vue&type=template&id=e8e5ac06&"
import script from "./edit-root-dirs.vue?vue&type=script&lang=js&"
export * from "./edit-root-dirs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports